
import { NAV_LINKS } from '../../constants'


export function crumbFor(href, fallback = []) {
  for (const navItem of NAV_LINKS) {
    if (!navItem.children) continue

    // Parent href: keep if non-empty string, otherwise null (dead text)
    const parentHref = navItem.href && navItem.href !== '' ? navItem.href : null

    for (const child of navItem.children) {

      // ── Grouped structure (IT Services, Consulting, AI/ML) ──
      // child = { heading, items: [...] }
      if (child.items) {
        const matched = child.items.find((item) => item.href === href)
        if (matched) {
          const trail = [{ label: navItem.label, href: parentHref }]
          if (child.heading) trail.push({ label: child.heading, href: null })
          trail.push({ label: matched.label, href: null })
          return trail
        }
      }

      // ── Flat structure (Know Us, Portfolio) ──
      // child = { label, href, ... }
      if (child.href === href) {
        return [
          { label: navItem.label, href: parentHref },
          { label: child.label,   href: null },
        ]
      }
    }
  }

  // Page not found in NAV_LINKS — use manual fallback
  return fallback
}

/** Returns the NAV_LINKS entry ({ label, desc, icon, … }) for a route, or null if none matches. */
export function navItemFor(href) {
  for (const navItem of NAV_LINKS) {
    for (const child of navItem.children ?? []) {
      if (child.href === href) return child

      const matched = child.items?.find((item) => item.href === href)
      if (matched) return matched
    }
  }
  return null
}

/** Page <title>: "<nav label> | CruxBytes Consultancy Services" */
export function metaTitleFor(href) {
  const { label = '', pageDesc = '', metaDesc = '' } = navItemFor(href) ?? {}
  return { label, pageDesc,metaDesc }
}